// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12cdE","toggle":"styles_toggle__2Z7Nc","preview":"styles_preview__37iGC"};